export default "__VITE_ASSET__RaCIAZfK__ 480w, __VITE_ASSET__DqB33G5r__ 768w, __VITE_ASSET__DpbmlKfS__ 1200w, __VITE_ASSET__C5bX5u9U__ 1920w";